// chakra imports
import { Box, Flex, Stack } from "@chakra-ui/react";
// //   Custom components
// import Brand from "components/sidebar/components/Brand";
import Links from "components/sidebar/components/Links";
import SidebarCard from "components/sidebar/components/SidebarCard";
import React from "react";

// FUNCTIONS

function SidebarContent(props) {
  // console.log('props', props);
  // const { routes } = props;
  // console.log("📱 Sidebar Content routes:", routes);
  // const { routes, isCollapsed } = props;
  const { routes, isCollapsed, onClose } = props;

  //const visibleRoutes = routes.filter(route => !route.hide);
  const visibleRoutes = routes;

  // SIDEBAR
  return (
    // <Flex direction='column' height='100%' pt='25px' borderRadius='30px'>
    <Flex direction='column' height='100%' pt='10px' borderRadius='0px'>
      {/* <Brand /> */}
      <Stack direction='column' mb='auto' mt='8px'>
        {/* <Box ps='20px' pe={{ md: "16px", "2xl": "1px" }}>
          <Links routes={visibleRoutes} /> */}
        <Box ps={isCollapsed ? "5px" : "10px"} pe={{ md: "8px", "2xl": "1px" }} transition="all 0.25s ease">
          <Links routes={visibleRoutes} isCollapsed={isCollapsed} onClose={onClose} />
        </Box>
      </Stack>

      {!isCollapsed && (
        <Box
          ps='20px'
          pe={{ md: "16px", "2xl": "0px" }}
          mt='60px'
          mb='40px'
          borderRadius='30px'>
          <SidebarCard />
        </Box>
      )}
    </Flex>
  );
}

export default SidebarContent;
